import { reducer } from '../reducers/auth';
import { authRootSaga } from '../sagas/auth';
import { saga, store } from '../store';

store.addReducers({ auth: reducer });
saga.run(authRootSaga);
